module.exports = __webpack_public_path__ + "media/role_selection/personal_shopper-ad68b1e4.png";